import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#244B5A',
    },
    secondary: {
      main: '#B0BCAF',
    },
    error: {
      main: '#EFA693',
    },
    warning: {
      main: '#ECD798'
    },
    // success: {
    //   main: '#EEF4E0'
    // },
    info: {
      main: '#788E98'
    },
    background: {
      default: '#fff',
    },
  },
});

export default theme;
